// extracted by mini-css-extract-plugin
module.exports = {"header":"SettingsHeader_header__2IsM7","title":"SettingsHeader_title__2uusZ"};